var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asset-cell" },
    [
      _vm.asset
        ? [
            _vm.isImage
              ? _c(
                  "div",
                  { staticClass: "image-preview" },
                  [
                    _c("viewer", { attrs: { images: [_vm.assetUrl] } }, [
                      _c(
                        "div",
                        {
                          staticClass: "thumbnail-wrapper",
                          on: { click: _vm.showImagePreview },
                        },
                        [
                          _c("img", {
                            staticClass: "thumbnail",
                            attrs: { src: _vm.assetUrl, alt: "Asset Image" },
                          }),
                          _vm._v(" "),
                          _vm.hovered
                            ? _c("md-icon", { staticClass: "preview-icon" }, [
                                _vm._v("visibility"),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              : _vm.isVideo
              ? _c(
                  "div",
                  {
                    staticClass: "video-preview",
                    on: { click: _vm.showVideoModal },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "video-thumbnail" },
                      [
                        _c("md-icon", { staticClass: "play-icon" }, [
                          _vm._v("play_circle_outline"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "watch-video-link" }, [
                          _vm._v("Videoyu İzle"),
                        ]),
                      ],
                      1
                    ),
                  ]
                )
              : _vm.isAudio
              ? _c(
                  "div",
                  { staticClass: "audio-preview" },
                  [
                    _c(
                      "div",
                      { on: { click: _vm.toggleAudio } },
                      [
                        _c("md-icon", [
                          _vm._v(
                            _vm._s(_vm.paused ? "play_circle" : "pause_circle")
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("av-waveform", {
                      attrs: {
                        "audio-src": _vm.assetUrl,
                        playtime: false,
                        playtimeWithMs: false,
                        playtimeTextBottom: false,
                        playtimeSliderWidth: 10,
                        noplayedLineColor: "#ff671b",
                        playedLineColor: "#1890ff",
                        playedLineWidth: 10,
                        playtimeFontSize: 25,
                      },
                    }),
                  ],
                  1
                )
              : _c("div", { staticClass: "file-preview" }, [
                  _c(
                    "div",
                    { staticClass: "file-icon" },
                    [
                      _vm.isWordFile
                        ? _c(
                            "md-icon",
                            { style: { color: _vm.randomColor() } },
                            [_vm._v("description")]
                          )
                        : _vm.isExcelFile
                        ? _c(
                            "md-icon",
                            { style: { color: _vm.randomColor() } },
                            [_vm._v("grid_on")]
                          )
                        : _vm.isPdfFile
                        ? _c(
                            "md-icon",
                            { style: { color: _vm.randomColor() } },
                            [_vm._v("picture_as_pdf")]
                          )
                        : _c(
                            "md-icon",
                            { style: { color: _vm.randomColor() } },
                            [_vm._v("insert_drive_file")]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      style: { color: _vm.randomColor() },
                      attrs: {
                        href: _vm.assetUrl,
                        target: "_blank",
                        download: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.asset.name) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
          ]
        : _c(
            "a-upload",
            {
              attrs: {
                "before-upload": _vm.beforeUpload,
                "custom-request": _vm.uploadFile,
                "show-upload-list": false,
                accept: _vm.acceptedFileTypes,
              },
            },
            [
              _c(
                "div",
                { staticClass: "upload-button" },
                [
                  _c("md-icon", [_vm._v(_vm._s(_vm.uploadIcon))]),
                  _vm._v(
                    "\n            " + _vm._s(_vm.uploadText) + "\n        "
                  ),
                ],
                1
              ),
            ]
          ),
      _vm._v(" "),
      _vm.showModal
        ? _c(
            "Modal2",
            {
              attrs: {
                "show-footer": false,
                "show-title": false,
                className: "asset-viewer-modal keydown-prevent-modal",
              },
              on: { cancel: _vm.closeModal },
            },
            [
              _c("video-player", {
                ref: "modalVideoPlayer",
                staticClass: "modal-video-player",
                attrs: { options: _vm.playerOptions(), playsinline: true },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }